import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { IMAGES } from "../constent/theme";

const Gallery = () => {
  const images = [
    { img: IMAGES.gallery1 },
    { img: IMAGES.gallery2 },
    { img: IMAGES.gallery3 },
    { img: IMAGES.gallery4 },
    { img: IMAGES.gallery5 },
    { img: IMAGES.gallery6 },
    { img: IMAGES.gallery7 },
    { img: IMAGES.gallery8 },
    { img: IMAGES.gallery9 },
    { img: IMAGES.gallery10 },
    { img: IMAGES.gallery11 },
    { img: IMAGES.gallery12 },
    { img: IMAGES.gallery13 },
    { img: IMAGES.gallery14 },
    { img: IMAGES.gallery15 },
  ];

  return (
    <div className="container">
      <Swiper
        className="swiper team-swiper swiper-visible swiper-btn-lr swiper-item-4"
        slidesPerView={4}
        spaceBetween={30}
        loop={true}
        speed={1200}
        modules={[Autoplay, Navigation]}
        watchSlidesProgress={true}
        navigation={{
          prevEl: ".team-button-prev",
          nextEl: ".team-button-next",
        }}
        autoplay={{
          delay: 1500,
        }}
        onSwiper={(swiper) => {
          requestAnimationFrame(() => swiper.update());
        }}
        breakpoints={{
          1200: { slidesPerView: 4 },
          991: { slidesPerView: 3 },
          575: { slidesPerView: 2 },
          240: { slidesPerView: 1 },
        }}
      >
        {images.map((img, ind) => (
          <SwiperSlide className="swiper-slide" key={ind}>
            <div className="dz-team style-1">
              <div className="dz-media">
                <img
                  src={img.img}
                  alt={`Gallery ${ind + 1}`}
                  className="gallery-image img-fluid"
                />
              </div>
            </div>
          </SwiperSlide>
        ))}
        <div className="pagination mt-xl-0 m-t40">
          <div className="team-button-prev btn-prev-long">
            <i className="fa-solid fa-arrow-left"></i>
          </div>
          <div className="team-button-next btn-next-long">
            <i className="fa-solid fa-arrow-right"></i>
          </div>
        </div>
      </Swiper>
    </div>
  );
};

export default Gallery;
